/**
 * CRDT Document Sync Types
 *
 * Types for Conflict-free Replicated Data Type (CRDT) based collaborative editing
 * using Yjs for real-time document synchronization.
 */
/**
 * Sync message types for CRDT protocol
 */
export var CRDTSyncMessageType;
(function (CRDTSyncMessageType) {
    CRDTSyncMessageType[CRDTSyncMessageType["SYNC_STEP_1"] = 0] = "SYNC_STEP_1";
    CRDTSyncMessageType[CRDTSyncMessageType["SYNC_STEP_2"] = 1] = "SYNC_STEP_2";
    CRDTSyncMessageType[CRDTSyncMessageType["UPDATE"] = 2] = "UPDATE";
    CRDTSyncMessageType[CRDTSyncMessageType["AWARENESS"] = 3] = "AWARENESS";
})(CRDTSyncMessageType || (CRDTSyncMessageType = {}));
/**
 * CRDT Operation types
 */
export var CRDTOperationType;
(function (CRDTOperationType) {
    CRDTOperationType["INSERT"] = "insert";
    CRDTOperationType["DELETE"] = "delete";
    CRDTOperationType["FORMAT"] = "format";
    CRDTOperationType["SET_METADATA"] = "set_metadata";
})(CRDTOperationType || (CRDTOperationType = {}));
/**
 * Sync Status
 */
export var SyncStatus;
(function (SyncStatus) {
    SyncStatus["DISCONNECTED"] = "disconnected";
    SyncStatus["CONNECTING"] = "connecting";
    SyncStatus["SYNCING"] = "syncing";
    SyncStatus["SYNCED"] = "synced";
    SyncStatus["ERROR"] = "error";
})(SyncStatus || (SyncStatus = {}));
/**
 * Conflict Resolution Strategy
 */
export var ConflictResolutionStrategy;
(function (ConflictResolutionStrategy) {
    ConflictResolutionStrategy["LAST_WRITE_WINS"] = "last_write_wins";
    ConflictResolutionStrategy["TIMESTAMP_ORDERED"] = "timestamp_ordered";
    ConflictResolutionStrategy["CAUSAL_ORDERING"] = "causal_ordering";
})(ConflictResolutionStrategy || (ConflictResolutionStrategy = {}));
//# sourceMappingURL=crdt.js.map